import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=24e12526&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=ts"
export * from "./HeaderTemplate.vue?vue&type=script&lang=ts"
import style0 from "./HeaderTemplate.vue?vue&type=style&index=0&id=24e12526&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e12526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e12526')) {
      api.createRecord('24e12526', component.options)
    } else {
      api.reload('24e12526', component.options)
    }
    module.hot.accept("./HeaderTemplate.vue?vue&type=template&id=24e12526&scoped=true", function () {
      api.rerender('24e12526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/HeaderTemplate.vue"
export default component.exports